import React, { useEffect, useState } from "react";
import {
  designListActions,
  useDesignListState,
  useDispatchDesignList
} from "../../../reducers/designlist.reducer";
import ThumbList from "../../molecules/ThumbList";
import classNames from "classnames";

function SearchByImageResult(props) {
  const { hidden } = props;
  const designListState = useDesignListState();
  const { selectedFile, searchResultsByImage } = designListState;
  const dispatchDesignList = useDispatchDesignList();
  const [searchResults, setSearchResults] = useState(searchResultsByImage);

  useEffect(() => {
    setSearchResults(searchResultsByImage);
  }, [searchResultsByImage]);
  const onThumbnailClick = (node, e) => {
    if (!node.designProps) return;
    const activeNode = selectedFile;

    if (activeNode)
      if (node.id === activeNode.id) {
        console.info("clicked in active node");
        return;
      }

    dispatchDesignList({
      type: designListActions.SELECT_DESIGN,
      payload: { selectedFile: node }
    });
  };
  return (
    <div className={classNames("at-search", { hidden: hidden })}>
      {" "}
      <ThumbList
        thumbList={searchResults}
        onThumbnailClick={onThumbnailClick}
        activeId={selectedFile.id}
        lazyDesignThumbnail={true}
      />
    </div>
  );
}

export default SearchByImageResult;
